export default __webpack_public_path__ + "0a598a2e75bdc4e95ed9df2c4f3461b287c2e35b37c30eedc4e10250094ea773.svg";